import { FC } from 'react';
import { InputSelect, InputSelectProps } from '@lambdacurry/component-library';
import { usStates } from 'lib/data';

export interface InputStateProps extends Omit<InputSelectProps, 'name' | 'label' | 'options'> {
  name?: InputSelectProps['name'];
  label?: InputSelectProps['label'];
  options?: InputSelectProps['options'];
}

export const InputState: FC<InputStateProps> = ({ name = 'state', label = 'State', options = usStates, ...props }) => (
  <InputSelect name={name} label={label} options={options} {...props} />
);

InputState.defaultProps = {
  optionValueKey: 'abbr',
  optionLabelKey: 'name',
  inputProps: { autoComplete: 'on' },
  autocompleteConfig: {
    disableClearable: false
  }
};
